import { MediaItem, CuratedCollection } from '../types';

export const INITIAL_MEDIA_ITEMS: MediaItem[] = [
  // 1. Bola de Drac (Dragon Ball) - EXACT user series data
  {
    id: 'bola-de-drac',
    type: 'series',
    title: 'Bola de Drac',
    originalTitle: 'ドラゴンボール',
    summary: "L'argument se centra en en Son Goku, la Bulma, i la recerca de les llegendàries boles de drac, un total de set boles que en ser reunides donen lloc a l'aparició del drac Shenron que pot concedir qualsevol desig. Un cop el desig s'ha acomplert, les boles es reparteixen novament per tot el món i són convertides en pedra durant un any. En el passat, costava generacions buscar les boles per tot el món i aplegar-les totes. Tanmateix, una genial inventora, la Bulma, crea el \"radar de les boles de drac\" per detectar les boles i fer el procés molt més fàcil.",
    poster: 'https://image.tmdb.org/t/p/original/qevKflDRoskXnifUjz8QbS61lox.jpg',
    backdrop: 'https://image.tmdb.org/t/p/original/30L49n4Dhn7dzuGG50GV3ybMhC3.jpg',
    genres: ['Acció i Aventura', 'Ciència-ficció i Fantasia', 'Clàssics 3XL'],
    tmdbId: 12609,
    rating: 8.5,
    year: '1986',
    status: 'Finalitzada',
    numberOfSeasons: 1,
    numberOfEpisodes: 153,
    featured: true,
    collections: ['classics-3xl', 'aventures-shonen', 'saga-bola-de-drac'],
    audioLanguage: 'Català (Doblatge Original TV3)',
    addedAt: '2026-08-27T11:40:22.183Z',
    episodes: [
      {
        tmdb_id: 484769,
        season: 1,
        episode: 1,
        title: 'Bulma i Son Goku',
        plot: "En Son Goku és un nen normal i corrent que viu al peu del pic de Paozu. Un bon dia topa amb la Bulma, una noia que busca boles de drac i que ja n'ha trobat tres. A part del seu avi, que ja és mort, en Son Goku no havia vist mai cap altra persona i, per a ell, la Bulma és com un extraterrestre. Tot anant cap a la cabana d'en Son Goku, la Bulma descobreix que en Son Goku té una bola de drac. En Son Goku li explica que era del seu avi, i que és l'últim record que en té. La Bulma explica a en Son Goku que, quan totes set boles de drac estiguin juntes, al seu posseïdor se li concedirà el compliment d'un desig. Vol que en Son Goku li doni la seva, però ell s'hi nega, ja que és una de les poques coses que li va deixar el seu avi. Però la Bulma, almenys, convenç en Son Goku que l'acompanyi en la recerca, amb la promesa que s'ho passaran molt bé.",
        air_date: '1986-02-26',
        runtime: 25,
        rating: 7.5,
        poster: 'https://image.tmdb.org/t/p/original/2RSrQ82HNbBBVM3omiHObQ0EvqI.jpg',
        stream_url: 'https://telegram.garco.ovh/stream/9984?token=3ieBt2A5AdQQkGXjSKoLrZR3pxK3Cq1uA454qHw0VlTsJljhOTjb6PQ4B7OJO063'
      },
      {
        tmdb_id: 484770,
        season: 1,
        episode: 2,
        title: 'La primera part del viatge',
        plot: "La Bulma i en Son Goku fan quilòmetres fins que es fa fosc. Ella fa una casa amb una altra de les càpsules i en Son Goku es pensa que és una bruixa. En Son Goku entra al lavabo mentre la Bulma es banya i li pregunta per què té un segon \"darrere\" al pit. La Bulma li explica que no és un darrere, que, justament, es diuen ¿pits? i li clava una escridassada i li llança una ampolla de xampú al cap. En Son Goku constata que la Bulma menja coses molt estranyes i surt a caçar-se el sopar. Topa amb en Xao i la Mai, dos dels agents del malvat emperador Pilaf que també busquen les boles de drac. Més tard, en Son Goku es desperta i recorda amb enyorança que, de més petit, feia servir el seu avi de coixí. Intenta fer el mateix posant el cap entre les cames de la Bulma i s'adona que hi ha alguna diferència anatòmica. Li treu les calces a la noia per inspeccionar-la detingudament i queda horroritzat en veure que li falta una cosa.",
        air_date: '1986-03-05',
        runtime: 25,
        rating: 7.727,
        poster: 'https://image.tmdb.org/t/p/original/vS0G7ECluRUQA2nxnBvZRremBnf.jpg',
        stream_url: 'https://telegram.garco.ovh/stream/9983?token=3ieBt2A5AdQQkGXjSKoLrZR3pxK3Cq1uA454qHw0VlTsJljhOTjb6PQ4B7OJO063'
      },
      {
        tmdb_id: 484771,
        season: 1,
        episode: 3,
        title: 'Els núvols del Follet Tortuga',
        plot: "En Son Goku porta l'Umigame cap al mar. Finalment, en Son Goku i la Bulma arriben al mar, i l'Umigame els diu que s'esperin, que va a buscar un amic. En Songoku queda meravellat per la quantitat d'aigua que hi ha en el \"gran riu\". La Bulma s'ho passa molt bé jugant a la sorra. L'Umigame torna amb un curiós ermità a sobre la closca. La tortuga explica al Follet Tortuga que en Son Goku l'ha ajudat a tornar al mar, i aquest, com a premi, dóna a en Son Goku el núvol Kinton, que només transporta persones de cor pur. La Bulma veu que l'ancià té una bola de drac i li demana que la hi doni, però el Follet Tortuga vol alguna cosa a canvi. La Bulma s'aixeca les faldilles creient que li ensenyarà les calces però, és clar, en Goku les hi ha tret durant la nit. El Follet Tortuga, molt agraït, li dóna la Bola de Drac.",
        air_date: '1986-03-12',
        runtime: 25,
        rating: 7.9,
        poster: 'https://image.tmdb.org/t/p/original/ownnqGkVVsYxCL6zhRqje1aA2D5.jpg',
        stream_url: 'https://telegram.garco.ovh/stream/9982?token=3ieBt2A5AdQQkGXjSKoLrZR3pxK3Cq1uA454qHw0VlTsJljhOTjb6PQ4B7OJO063'
      },
      {
        tmdb_id: 484772,
        season: 1,
        episode: 4,
        title: 'Oolong, el monstre segrestador',
        plot: "En Son Goku i la Bulma arriben a un poble terroritzat per un monstre canviaformes anomenat Oolong, que segresta noies joves. En Son Goku accepta ajudar el poble a canvi de la Bola de Drac de sis estrelles.",
        air_date: '1986-03-19',
        runtime: 25,
        rating: 7.6,
        poster: 'https://image.tmdb.org/t/p/original/2RSrQ82HNbBBVM3omiHObQ0EvqI.jpg',
        stream_url: 'https://telegram.garco.ovh/stream/9984?token=3ieBt2A5AdQQkGXjSKoLrZR3pxK3Cq1uA454qHw0VlTsJljhOTjb6PQ4B7OJO063'
      },
      {
        tmdb_id: 484773,
        season: 1,
        episode: 5,
        title: 'Yamcha, el bandoler del desert',
        plot: "Mentre creuen el desert abrasador, el grup és atacat pel temible Yamcha i el seu fidel company Puar. Una gran batalla comença!",
        air_date: '1986-03-26',
        runtime: 25,
        rating: 7.8,
        poster: 'https://image.tmdb.org/t/p/original/vS0G7ECluRUQA2nxnBvZRremBnf.jpg',
        stream_url: 'https://telegram.garco.ovh/stream/9983?token=3ieBt2A5AdQQkGXjSKoLrZR3pxK3Cq1uA454qHw0VlTsJljhOTjb6PQ4B7OJO063'
      }
    ]
  },

  // 2. Movie 1 - EXACT user movie data
  {
    id: 'vall-encantada-2',
    type: 'movie',
    title: 'A la recerca de la vall encantada II: Aventura a la gran vall',
    originalTitle: 'The Land Before Time II: The Great Valley Adventure',
    summary: "Els cinc petits amics continuen buscant aventures, encara que per això s'han d'allunyar de la seguretat de la vall, convençuts per la trapella Saura. Pel camí, sorprenen dos dinosaures que estaven robant un ou de tiranosaure. Quan neix el petit, s'uneix a la intrèpida colla, que ha arribat a la inexplorada Terra del Més enllà.",
    poster: 'https://image.tmdb.org/t/p/original/8gWdRc32EBy99uGKOAfTC53kbgQ.jpg',
    backdrop: 'https://image.tmdb.org/t/p/original/8Db2ogq0e4UepMMxwqdv79YJMNq.jpg',
    genres: ['Aventura'],
    tmdbId: 15997,
    rating: 6.291,
    year: '1994',
    runtime: 73,
    streamUrl: 'https://telegram.garco.ovh/stream/3409?token=3ieBt2A5AdQQkGXjSKoLrZR3pxK3Cq1uA454qHw0VlTsJljhOTjb6PQ4B7OJO063',
    featured: false,
    collections: ['pellicules-nostalgia', 'aventura-dinousaures'],
    audioLanguage: 'Català (Doblatge Original)',
    addedAt: '2026-08-27T11:40:51.262Z'
  },

  // 3. Movie 2 - EXACT user movie data
  {
    id: 'vall-encantada-3',
    type: 'movie',
    title: 'A la recerca de la Vall Encantada III: La font de la vida',
    originalTitle: 'The Land Before Time III: The Time of the Great Giving',
    summary: "Un enorme meteorit ha caigut a la Gran Vall, cosa que talla el subministrament d'aigua i crea tensió entre els dinosaures que hi habiten. En Dinet i companyia busquen més aigua i troben un gran dipòsit atrapat entre la Gran Vall i el “misteriós més enllà”, llar de les temibles dentegades. Aquest tercer lliurament de les aventures del petit dinosaure va ser directament a vídeo, tant als EUA com a Europa.",
    poster: 'https://image.tmdb.org/t/p/original/je6Woifepch4fHy5RbnoyeKvodc.jpg',
    backdrop: 'https://image.tmdb.org/t/p/original/iH3w4JwrsslnDKkNi5kLtiNh7DN.jpg',
    genres: ['Aventura'],
    tmdbId: 19004,
    rating: 6.2,
    year: '1995',
    runtime: 70,
    streamUrl: 'https://telegram.garco.ovh/stream/3405?token=3ieBt2A5AdQQkGXjSKoLrZR3pxK3Cq1uA454qHw0VlTsJljhOTjb6PQ4B7OJO063',
    featured: false,
    collections: ['pellicules-nostalgia', 'familia-animacio'],
    audioLanguage: 'Català (Doblatge Original)',
    addedAt: '2026-08-27T11:40:51.262Z'
  },

  // 4. Detectiu Conan (Detective Conan)
  {
    id: 'detectiu-conan',
    type: 'series',
    title: 'El Detectiu Conan',
    originalTitle: '名探偵コナン',
    summary: "En Shinichi Kudo és un jove i brillant detectiu d'institut que és enverinat per una organització criminal secreta (els Homes de Negre). Lluny de morir, el verí el transforma en un nen de set anys. Amb la nova identitat de Conan Edogawa, s'instal·la a viure amb la seva amiga de la infància Ran Mouri i el seu pare, el mediocre detectiu Kogoro Mouri, per resoldre casos misteriosos en secret i buscar un antídot.",
    poster: 'https://image.tmdb.org/t/p/original/rN0oN7C3mQ8M4g1b7G6x1jB8s8c.jpg',
    backdrop: 'https://image.tmdb.org/t/p/original/xWwB0G7e7Zl5v2jU3u0zR5lqG4W.jpg',
    genres: ['Misteri', 'Comèdia', 'Clàssics 3XL'],
    tmdbId: 2362,
    rating: 8.6,
    year: '1996',
    status: 'En emissió',
    numberOfSeasons: 1,
    numberOfEpisodes: 1000,
    featured: true,
    collections: ['classics-3xl', 'misteri-i-thriller'],
    audioLanguage: 'Català (Doblatge TV3 / SX3)',
    addedAt: '2026-08-27T10:00:00.000Z',
    episodes: [
      {
        tmdb_id: 11001,
        season: 1,
        episode: 1,
        title: 'L\'assassinat de la muntanya russa',
        plot: "En Shinichi Kudo acompanya la Ran al parc d'atraccions Tropical Land. Durant el viatge a la muntanya russa Mystery Coaster, un passatger és decapitat misteriosament. En Shinichi descobreix el culpable abans de topar amb els Homes de Negre.",
        air_date: '1996-01-08',
        runtime: 24,
        rating: 8.4,
        poster: 'https://image.tmdb.org/t/p/original/rN0oN7C3mQ8M4g1b7G6x1jB8s8c.jpg',
        stream_url: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4'
      },
      {
        tmdb_id: 11002,
        season: 1,
        episode: 2,
        title: 'El segrest de la filla del president',
        plot: "Després d'haver encallat en el cos d'un nen de primària, en Shinichi adopta el nom de Conan Edogawa amb l'ajuda del professor Agasa. El seu primer cas serà rescatar una noia segrestada.",
        air_date: '1996-01-15',
        runtime: 24,
        rating: 8.1,
        poster: 'https://image.tmdb.org/t/p/original/rN0oN7C3mQ8M4g1b7G6x1jB8s8c.jpg',
        stream_url: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4'
      }
    ]
  },

  // 5. Inuyasha
  {
    id: 'inuyasha',
    type: 'series',
    title: 'Inuyasha',
    originalTitle: '犬夜叉',
    summary: "La Kagome Higurashi és transportada a través d'un pou del seu santuari familiar al Japó feudal de l'era Sengoku. Allà descobreix que posseeix l'Esfera dels Quatre Esperits (Shikon no Tama) i desperta el mig dimoni Inuyasha. Quan l'esfera es fragmenta per tot el país, junts emprendran un viatge èpic.",
    poster: 'https://image.tmdb.org/t/p/original/a0V3p8R7aQ1qf7v5z3eKj8wZ9mK.jpg',
    backdrop: 'https://image.tmdb.org/t/p/original/4uV1VqLh3aFpZ5xS7j9M5hP2aQ8.jpg',
    genres: ['Acció i Aventura', 'Fantasia', 'Clàssics 3XL'],
    tmdbId: 4614,
    rating: 8.4,
    year: '2000',
    status: 'Finalitzada',
    numberOfSeasons: 1,
    numberOfEpisodes: 167,
    featured: true,
    collections: ['classics-3xl', 'aventures-shonen'],
    audioLanguage: 'Català (Doblatge 3XL)',
    addedAt: '2026-08-27T09:00:00.000Z',
    episodes: [
      {
        tmdb_id: 12001,
        season: 1,
        episode: 1,
        title: 'La noia que va viatjar a través del temps i el noi segellat',
        plot: "La Kagome cau a un pou misteriós al temple familiar el dia del seu quinzè aniversari i apareix al Japó feudal, on allibera un jove amb orelles de gos segellat a un arbre sagrat.",
        air_date: '2000-10-16',
        runtime: 24,
        rating: 8.5,
        poster: 'https://image.tmdb.org/t/p/original/a0V3p8R7aQ1qf7v5z3eKj8wZ9mK.jpg',
        stream_url: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/TearsOfSteel.mp4'
      }
    ]
  },

  // 6. Sakura, la caçadora de cartes
  {
    id: 'sakura-cardcaptor',
    type: 'series',
    title: 'Sakura, la caçadora de cartes',
    originalTitle: 'カードキャプターさくら',
    summary: "La Sakura Kinomoto, una nena de deu anys, descobreix un llibre màgic al soterrani de casa seva i allibera sense voler les misterioses Cartes Clow. Guiada per en Keroberos, el guardià del llibre, haurà de recuperar totes les cartes abans que provoquin una catàstrofe.",
    poster: 'https://image.tmdb.org/t/p/original/3iU6pM5N1wY5bF4d8K9z8qL1w7H.jpg',
    backdrop: 'https://image.tmdb.org/t/p/original/6vQ8f3M4b8p7D9K2wL8Z3xX1yG7.jpg',
    genres: ['Fantasia', 'Màgia', 'Clàssics 3XL'],
    tmdbId: 4629,
    rating: 8.3,
    year: '1998',
    status: 'Finalitzada',
    numberOfSeasons: 3,
    numberOfEpisodes: 70,
    featured: false,
    collections: ['classics-3xl', 'magia-i-fantasia'],
    audioLanguage: 'Català (Doblatge K3)',
    addedAt: '2026-08-27T08:30:00.000Z',
    episodes: [
      {
        tmdb_id: 13001,
        season: 1,
        episode: 1,
        title: 'La Sakura i el llibre màgic misteriós',
        plot: "La Sakura obre un estrany llibre a la biblioteca del seu pare i escampa per tota la ciutat de Tomoeda les cartes màgiques de Clow Reed.",
        air_date: '1998-04-07',
        runtime: 25,
        rating: 8.2,
        poster: 'https://image.tmdb.org/t/p/original/3iU6pM5N1wY5bF4d8K9z8qL1w7H.jpg',
        stream_url: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4'
      }
    ]
  },

  // 7. El Dr. Slump
  {
    id: 'dr-slump',
    type: 'series',
    title: 'El Dr. Slump',
    originalTitle: 'Dr. スランプ アラレちゃん',
    summary: "A la pintoresca Vila del Pingüí, el científic Senbei Norimaki crea una noia robot androide d'aspecte innocent anomenada Arale. L'Arale posseeix una força sobrehumana descomunal, una ingenuïtat hilarant i una obsessió per les caques de colors.",
    poster: 'https://image.tmdb.org/t/p/original/1zB4rX5oX9m6p7K2r8v3yQ9m5L0.jpg',
    backdrop: 'https://image.tmdb.org/t/p/original/8hL6jP4o5qR2m8z1k4v7xY3b8T9.jpg',
    genres: ['Comèdia', 'Ciència-ficció', 'Clàssics 3XL'],
    tmdbId: 12610,
    rating: 8.2,
    year: '1981',
    status: 'Finalitzada',
    numberOfSeasons: 1,
    numberOfEpisodes: 243,
    featured: false,
    collections: ['classics-3xl', 'comedia-nostalgia'],
    audioLanguage: 'Català (Doblatge TV3)',
    addedAt: '2026-08-27T08:00:00.000Z',
    episodes: [
      {
        tmdb_id: 14001,
        season: 1,
        episode: 1,
        title: 'El naixement de l\'Arale',
        plot: "En Senbei Norimaki crea el seu robot més avançat: l'Arale! Però aviat s'adona que la seva força descomunal i la seva miopia provocaran situacions descontrolades a la Vila del Pingüí.",
        air_date: '1981-04-08',
        runtime: 25,
        rating: 8.0,
        poster: 'https://image.tmdb.org/t/p/original/1zB4rX5oX9m6p7K2r8v3yQ9m5L0.jpg',
        stream_url: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4'
      }
    ]
  },

  // 8. Movie: El viatge de Chihiro (Spirited Away)
  {
    id: 'viatge-de-chihiro',
    type: 'movie',
    title: 'El viatge de Chihiro',
    originalTitle: '千と千尋の神隠し',
    summary: "La Chihiro, una nena de deu anys rondinaire, queda atrapada en un món màgic governat per la bruixa Yubaba després que els seus pares es converteixin en porcs. Treballant en una casa de banys termals per a esperits i déus, haurà de trobar la valentia per alliberar la seva família.",
    poster: 'https://image.tmdb.org/t/p/original/39wmItIWsg5sZMyRUHLkWBcuVCM.jpg',
    backdrop: 'https://image.tmdb.org/t/p/original/bSXfCvTXT8XJHqaAY9oplCYL37P.jpg',
    genres: ['Fantasia', 'Studio Ghibli'],
    tmdbId: 129,
    rating: 8.5,
    year: '2001',
    runtime: 125,
    streamUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
    featured: true,
    collections: ['ghibli-catala', 'obres-mestres'],
    audioLanguage: 'Català (Doblatge Oficial Cinema)',
    addedAt: '2026-08-27T07:00:00.000Z'
  }
];

export const INITIAL_COLLECTIONS: CuratedCollection[] = [
  {
    id: 'classics-3xl',
    title: 'Clàssics Mítics del 3XL i K3',
    slug: 'classics-3xl',
    description: 'Les sèries d\'anime que van marcar generacions a la televisió pública catalana.',
    iconName: 'Tv',
    bannerImage: 'https://image.tmdb.org/t/p/original/30L49n4Dhn7dzuGG50GV3ybMhC3.jpg',
    itemIds: ['bola-de-drac', 'detectiu-conan', 'inuyasha', 'sakura-cardcaptor', 'dr-slump'],
    order: 1
  },
  {
    id: 'saga-bola-de-drac',
    title: 'Univers Bola de Drac',
    slug: 'saga-bola-de-drac',
    description: 'Tots els episodis, sagues i aventures d\'en Son Goku i els seus amics a la recerca de les 7 boles.',
    iconName: 'Sparkles',
    bannerImage: 'https://image.tmdb.org/t/p/original/30L49n4Dhn7dzuGG50GV3ybMhC3.jpg',
    itemIds: ['bola-de-drac'],
    order: 2
  },
  {
    id: 'pellicules-nostalgia',
    title: 'Pel·lícules d\'Animació i Nostàlgia',
    slug: 'pellicules-nostalgia',
    description: 'Pel·lícules clàssiques i llargmetratges d\'aventures doblats al català.',
    iconName: 'Film',
    bannerImage: 'https://image.tmdb.org/t/p/original/8Db2ogq0e4UepMMxwqdv79YJMNq.jpg',
    itemIds: ['vall-encantada-2', 'vall-encantada-3', 'viatge-de-chihiro'],
    order: 3
  },
  {
    id: 'ghibli-catala',
    title: 'Studio Ghibli en Català',
    slug: 'ghibli-catala',
    description: 'Les obres mestres d\'Hayao Miyazaki i Isao Takahata amb veus en català.',
    iconName: 'Moon',
    bannerImage: 'https://image.tmdb.org/t/p/original/bSXfCvTXT8XJHqaAY9oplCYL37P.jpg',
    itemIds: ['viatge-de-chihiro'],
    order: 4
  }
];

export const ANIME_AVATARS = [
  { id: 'goku', name: 'Son Goku', url: 'https://images.unsplash.com/photo-1534447677768-be436bb09401?w=150&auto=format&fit=crop&q=80', badge: 'Saiyan' },
  { id: 'bulma', name: 'Bulma', url: 'https://images.unsplash.com/photo-1578632767115-351597cf2477?w=150&auto=format&fit=crop&q=80', badge: 'Càpsula Corp' },
  { id: 'conan', name: 'Conan Edogawa', url: 'https://images.unsplash.com/photo-1563089145-599997674d42?w=150&auto=format&fit=crop&q=80', badge: 'Detectiu' },
  { id: 'inuyasha', name: 'Inuyasha', url: 'https://images.unsplash.com/photo-1607604276583-eef5d076aa5f?w=150&auto=format&fit=crop&q=80', badge: 'Mitjà-Dimoni' },
  { id: 'sakura', name: 'Sakura Kinomoto', url: 'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=150&auto=format&fit=crop&q=80', badge: 'Caçadora' },
  { id: 'arale', name: 'Arale Norimaki', url: 'https://images.unsplash.com/photo-1579783902614-a3fb3927b675?w=150&auto=format&fit=crop&q=80', badge: 'Androide' }
];
